module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-pt-br.a9a6399e02cab0e70da8.svg";